import React, { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import { useLocation, useParams } from 'react-router-dom';
import { AnimatePresence, motion } from "framer-motion";
import { useMouse, useWindowSize } from '../../hooks/hooks';
import animA from '../../animations/animA';


const Page = ({ temp, children, fit, offset, className }) => {

  const { toDefault } = useMouse();
  const { projectId } = useParams();

  const { onDesk } = useWindowSize()
  const { ease } = animA();

  const pathname = useLocation().pathname;

  useEffect(() => {
    // TODO : ENABLE
    window.scrollTo({ top: 0, behavior: "instant" })
  }, [projectId, pathname]);


  // TODO : KEEP MOTION COMPONENT ONMOBILE
  const DeskPageMotion = onDesk ? motion.div : "div"     // DYNAMICALLY HANDLE MOTION WRAPPER

  return (

    temp ?

      <div className='w-full min-h-[90vh] flex flex-col items-center justify-center'>
        <h1>{pathname}</h1>
        <p className='mt-10 dim muted'>coming soon.</p>
      </div>

      :

      <AnimatePresence mode='wait'>
        <DeskPageMotion
          key={pathname}
          onMouseEnter={toDefault}
          initial={{ opacity: .1, scale: .95, transformOrigin: "top", translateY: -30, clipPath: "inset(0% 0% 100%)" }}
          animate={{ opacity: 1, scale: 1, transformOrigin: "top", translateY: 0, clipPath: "inset(0%)" }}
          exit={{ opacity: .2, scale: 1.2, transformOrigin: "top", translateY: -100, clipPath: "inset(100% 0% 0%)" }}
          transition={{ ease, duration: 1.2 }}
          className={twMerge(
            'flex flex-col relative bg-dark w-screen overflow-x-clip scrollbar-hide',
            fit ? "h-fit" : "min-h-[100dvh]",
            offset ? 'pt-24' : 'pt-0',
            className
          )}
        >
          {children}
        </DeskPageMotion >
      </AnimatePresence>
  )
}

export default Page
